





















































































import { api } from "@/api/api";
import { ApiGetTeachingMaterialCategoryDto, ApiUpsertTeachingMaterialDto } from "@/api/generated/Api";
import BaseModalForm from "@/components/shared/modal/BaseModalForm.vue";
import { ModalType } from "@/shared/enums/modalTypeEnum";
import { NotificationItemType } from "@/shared/enums/notificationItemEnum";
import { deepCloneObject } from "@/shared/helpers/deepCloneHelpers";
import { globalLoadingWrapper } from "@/shared/helpers/loadingHelpers";
import { openNotification } from "@/shared/helpers/store.helpers";
import { useStore } from "@/shared/useHelpers";
import { StoreState } from "@/store/store.state.interface";
import { computed, defineComponent, PropType, ref } from "@vue/composition-api";
import Vue from "vue";

export default defineComponent({
  name: "TeachingmaterialModal",
  components: { BaseModalForm },
  props: {
    modalType: {
      type: String as PropType<ModalType>,
      required: true,
    },
    headline: {
      type: String,
      required: true,
    },
    teachingMaterialCategories: {
      type: Array as PropType<ApiGetTeachingMaterialCategoryDto[]>,
      required: true,
    },
    existingItemModal: {
      type: Object as PropType<ApiUpsertTeachingMaterialDto>,
    },
    elementId: {
      type: Number,
    },
  },
  setup(props, { emit, refs }) {
    const store = useStore<StoreState>();
    const currentCategory = ref<ApiGetTeachingMaterialCategoryDto>();
    const categoryModel = ref<ApiUpsertTeachingMaterialDto>({
      name: "",
      description: "",
      category: "",
      attribute1: "",
      attribute2: "",
      attribute3: "",
      attribute4: "",
      attribute5: "",
      isActive: true,
    });

    const categoryChanged = () => {
      setActiveCategory(categoryModel.value.category ?? "");
    };

    const setActiveCategory = (nameOfActive: string) => {
      const element = props.teachingMaterialCategories.find((current) => current.name === nameOfActive);
      currentCategory.value = element;
    };

    const handleSubmit = () => {
      const isValid = (refs.connectForm as Vue & { validate: () => boolean }).validate();
      if (!isValid) {
        return;
      }
      if (props.modalType === ModalType.Add) {
        addCategory();
      } else if (props.modalType === ModalType.Edit) {
        editCategory();
      } else {
        openNotification(store, NotificationItemType.Error, "Det skjedde en feil");
      }
    };

    const addCategory = () => {
      globalLoadingWrapper({ blocking: true }, async () => {
        await api.teachingmaterial.createTeachingMaterialAsync(categoryModel.value);
        openNotification(store, NotificationItemType.Success, "Kategori lagt til");
        emit("close");
      });
    };

    const editCategory = () => {
      globalLoadingWrapper({ blocking: true }, async () => {
        if (!props.elementId) {
          throw new Error("Missing name on edit");
        }
        await api.teachingmaterial.updateTeachingMaterialAsync(props.elementId, categoryModel.value);
        openNotification(store, NotificationItemType.Success, `${categoryModel.value.name} oppdatert`);
        emit("close");
      });
    };

    if (props.existingItemModal && (props.modalType === ModalType.Edit || props.modalType === ModalType.Display)) {
      categoryModel.value = deepCloneObject(props.existingItemModal);
      setActiveCategory(categoryModel.value.category ?? "");
    }

    return {
      categoryModel,
      handleSubmit,
      readonly: computed(() => props.modalType === ModalType.Display),
      editMode: computed(() => props.modalType === ModalType.Edit),
      currentCategory,
      categoryChanged,
    };
  },
});
